import { render } from "./ErrorMssageCard.vue?vue&type=template&id=3ce7eab4&ts=true"
import script from "./ErrorMssageCard.vue?vue&type=script&lang=ts"
export * from "./ErrorMssageCard.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__